import { render, staticRenderFns } from "./LogoSpin.vue?vue&type=template&id=68430bcf&scoped=true"
import script from "./LogoSpin.vue?vue&type=script&lang=js"
export * from "./LogoSpin.vue?vue&type=script&lang=js"
import style0 from "./LogoSpin.vue?vue&type=style&index=0&id=68430bcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68430bcf",
  null
  
)

export default component.exports